export const INBOX_URL = '/inbox';
export const NEW_MESSAGE_URL = '/inbox/new';
export const CONVERSATION_URL = conversationId => "/inbox/".concat(conversationId);
export const CONVERSATION_URL_WITH_OFFER_REQUEST = conversationId => "/inbox/".concat(conversationId, "?offer_request=true");
export const INBOX_ITEM_PATH = itemId => "/inbox/?item_id=".concat(itemId);
export const INBOX_ROUTE_PATHS = {
  INBOX: 'inbox/*',
  NEW_MESSAGE: 'new',
  CONVERSATION: ':id'
};